import { Link } from '@tanstack/react-router'
import { ArrowUpRight, Infinity as InfinityIcon, MapPin } from 'lucide-react'
import { useListingGate } from '~/entities/subscription/model/use-listing-gate'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { Card, CardContent } from '~/shared/ui/card'

export function PlacesUsageCard() {
  const { isLoading, isUnlimited, used, max, atLimit } = useListingGate()

  if (isLoading) {
    return (
      <Card>
        <CardContent className="py-3">
          <p className="text-muted-foreground text-sm">{m.loading()}</p>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent className="flex flex-wrap items-center gap-4 py-3">
        <div className="flex items-center gap-2">
          {isUnlimited ? (
            <InfinityIcon className="h-4 w-4 shrink-0 text-brand" />
          ) : (
            <MapPin className="h-4 w-4 shrink-0 text-brand" />
          )}
          <p className="font-semibold text-sm">
            {isUnlimited
              ? m.placesUsedUnlimited()
              : m.placesUsed({ used: String(used), max: String(max) })}
          </p>
        </div>

        {atLimit && (
          <Link to="/dashboard/subscription" className="ml-auto">
            <Button size="sm" className="gap-1.5 bg-orange-600 text-white hover:bg-orange-700">
              <ArrowUpRight className="h-3.5 w-3.5" />
              {m.upgradeNow()}
            </Button>
          </Link>
        )}
      </CardContent>
    </Card>
  )
}
